<template>
  <div class="gamebox" v-if="bonus_id !== 0">
    <div class="top">
      <div class="gametitle">
        {{ $t(`lang.str_bonus_detail`) }}
      </div>
    </div>
    <div class="gameImgArea">
      <div class="box">
        <img :src="require('../../../assets/'+gamePath+'/bonus_' + bonus_id + '.png')" alt="" :class="{ deep: true }">
      </div>
    </div>
  </div>
</template>
<script>
import GameTitleLayout from "../../common/game_detail_title.vue";

export default {
    name: "SlotsBonusLayout",
    components: {GameTitleLayout},
    props: {
        gamePath:"",
        bonus_id:0,
        Phone: false,
    },
    data() {
      return {

      };
    },
    created() {

    },
    methods: {

    }
}
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/slots/layout/slots_bonus_layout.vue